import React, { useState, useCallback } from "react";
import ProjectDetailsForm from "../../components/ProjectForms/ProjectDetailsForm";
import { useNavigate } from "react-router-dom";
import { base64ToFile } from "../../utils/fileUtils";
import {
  
  createProject,
  getProjectDeatilaFormdata,
} from "../../services/projects";
import axiosInstance from "../../services/api/axios";
import { toast } from "react-toastify";

function CreateProject() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [projectId, setProjectId] = useState(0);
  const [projectDetails, setProjectDetails] = useState({});



  const getagreementFormdata = (agreementData, project_id) => {
    const formDataToSend = new FormData();
    formDataToSend.append("customer_id", agreementData.customer_id);
    formDataToSend.append("project_id", project_id);
    formDataToSend.append(
      "media",
      base64ToFile(agreementData.agreement.base64, agreementData.agreement.name)
    );
    return formDataToSend;
  };

  const executeProjectDeatils = async (projectDeatilaData) => {
    try {
      const formDataToSend = getProjectDeatilaFormdata(projectDeatilaData);
      const response = await createProject(formDataToSend);
      console.log("Raw API Response:", response);
      if (response.status === 422) {
        toast.error(
          "Invalid or missing required fields. Please check your input."
        );
        return null;
      } else {
        setProjectDetails(response);
        return response;
      }
    } catch (error) {
      console.error("Error in executeProjectDeatils:", error);
      toast.error("Error creating project details");
      return null;
    }
  };

  const executeAgreementTemplate = async (agreementData, project_id) => {
    try {
      const formDataToSend = getagreementFormdata(agreementData, project_id);
      await axiosInstance.post("/projects/agreement-template", formDataToSend);
    } catch (error) {
      console.error("Error in executeAgreementTemplate:", error);
      toast.error("Error creating agreement template");
    }
  };

  const handlePostRequests = async (projectDeatilaData) => {
    setIsSubmitting(true);
    try {
      const projectDetailsResponse = await executeProjectDeatils(
        projectDeatilaData
      );
      if (!projectDetailsResponse) {
        return;
      }
      console.log("Project Response:", projectDetailsResponse);

      // Extract projectId from different possible response structures
      // this si the reposne i get 
      // 0: {projectPhaseId: 13, ... project: {projectId: 15, ...}, ...}
      let projectId;
      if (
        Array.isArray(projectDetailsResponse) &&
        projectDetailsResponse.length > 0 &&
        projectDetailsResponse[0]?.project?.projectId
      ) {
        projectId = projectDetailsResponse[0].project.projectId;
      } else {
        console.error("Could not extract projectId from response:", projectDetailsResponse);
        toast.error("Project created but could not get project ID");
        return;
      }

      setProjectId(projectId);

      // Upload agreement template separately if it exists
      if (projectDeatilaData.agreement) {
        await executeAgreementTemplate(projectDeatilaData, projectId);
      }

      // Create Developer Project BOQ items per phase (after phases exist)
      const phasesResponse = Array.isArray(projectDetailsResponse) ? projectDetailsResponse : [];
      const phasesPayload = projectDeatilaData.phases || [];
      for (let i = 0; i < phasesResponse.length && i < phasesPayload.length; i++) {
        const boqItems = phasesPayload[i].boqItems;
        if (boqItems && boqItems.length > 0) {
          const phaseId = phasesResponse[i].projectPhaseId ?? phasesResponse[i].project_phase_id ?? phasesResponse[i].id;
          if (phaseId) {
            try {
              await axiosInstance.post("/interior-designers/developer-project-boq", {
                projectPhaseId: phaseId,
                items: boqItems.map((item) => ({
                  materialCategoryId: typeof item.materialCategoryId === "number" ? item.materialCategoryId : parseInt(item.materialCategoryId, 10),
                  details: String(item.details ?? "").trim(),
                })).filter((item) => item.materialCategoryId > 0),
              });
            } catch (err) {
              console.error(`Error creating BOQ for phase ${phaseId}:`, err);
              toast.error(`BOQ could not be saved for one phase. You can add it later from Project details.`);
            }
          }
        }
      }

      toast.success("Project Created Successfully");
      navigate(`/project-details/${projectId}`);
    } catch (error) {
      console.error("Error in handlePostRequests:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="">
        <ProjectDetailsForm
          onFormSave={handlePostRequests}
          setProjectId={setProjectId}
          isPostSubmitting={isSubmitting}
        />
      </div>
    </>
  );
}

export default CreateProject;
